module.exports = __webpack_public_path__ + "c70265cf9399d5cb64a473c4c053cd9f.png";